'use strict';
import * as $j_app$002etulz$002etuplez$002e$002dComposition$0024$0024anon$0024277 from "./app.tulz.tuplez.-Composition$$anon$277.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$Root$() {
  this.Lapp_pages_AppPage$Root$__f_route = null;
  this.Lapp_pages_AppPage$Root$__f_derived$CirceCodec$lzy1 = null;
  this.Lapp_pages_AppPage$Root$__f_derived$CirceCodecbitmap$1 = false;
  $n_Lapp_pages_AppPage$Root$ = this;
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_waypoint_Route$();
  var $x_1 = $m_Lapp_pages_AppPage$Root$();
  var this$2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_waypoint_package$().Lcom_raquo_waypoint_Waypoint__f_root;
  var that = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_waypoint_package$().endOfSegments__Lurldsl_language_PathSegment();
  var c = new $j_app$002etulz$002etuplez$002e$002dComposition$0024$0024anon$0024277.$c_Lapp_tulz_tuplez_Composition$$anon$277();
  this.Lapp_pages_AppPage$Root$__f_route = $x_2.static__O__Lurldsl_language_PathSegment__T__O__s_reflect_ClassTag__Lcom_raquo_waypoint_Route$Total($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lurldsl_language_PathSegment__$div__Lurldsl_language_PathSegment__Lapp_tulz_tuplez_Composition__Lurldsl_language_PathSegment(this$2, that, c), "", $m_Lapp_pages_AppPage$Root$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_reflect_ClassTag$GenericClassTag($d_Lapp_pages_AppPage$Root$.getClassOf()));
}
export { $c_Lapp_pages_AppPage$Root$ as $c_Lapp_pages_AppPage$Root$ };
$c_Lapp_pages_AppPage$Root$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$Root$.prototype.constructor = $c_Lapp_pages_AppPage$Root$;
/** @constructor */
function $h_Lapp_pages_AppPage$Root$() {
}
export { $h_Lapp_pages_AppPage$Root$ as $h_Lapp_pages_AppPage$Root$ };
$h_Lapp_pages_AppPage$Root$.prototype = $c_Lapp_pages_AppPage$Root$.prototype;
$c_Lapp_pages_AppPage$Root$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$Root$.prototype.hashCode__I = (function() {
  return 2553090;
});
$c_Lapp_pages_AppPage$Root$.prototype.toString__T = (function() {
  return "Root";
});
$c_Lapp_pages_AppPage$Root$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_pages_AppPage$Root$.prototype.productPrefix__T = (function() {
  return "Root";
});
$c_Lapp_pages_AppPage$Root$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$Root$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$Root$.prototype.derived$CirceCodec__Lio_circe_Codec = (function() {
  if ((!this.Lapp_pages_AppPage$Root$__f_derived$CirceCodecbitmap$1)) {
    var configuration$proxy1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().Lio_circe_derivation_Configuration$__f_default;
    var decoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var encoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var labels = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var fromProduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var \u03b41$ = $m_Lapp_pages_AppPage$Root$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p) => \u03b41$));
    }));
    var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$()));
    var defaults = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(values);
    this.Lapp_pages_AppPage$Root$__f_derived$CirceCodec$lzy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_ConfiguredCodec$$anon$3(configuration$proxy1, "Root", fromProduct, decoders, encoders, labels, defaults);
    this.Lapp_pages_AppPage$Root$__f_derived$CirceCodecbitmap$1 = true;
  }
  return this.Lapp_pages_AppPage$Root$__f_derived$CirceCodec$lzy1;
});
$c_Lapp_pages_AppPage$Root$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_pages_AppPage$Root$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$Root$, "app.pages.AppPage$Root$", ({
  Lapp_pages_AppPage$Root$: 1,
  Lapp_pages_AppPage: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_pages_AppPage$Root$ as $d_Lapp_pages_AppPage$Root$ };
var $n_Lapp_pages_AppPage$Root$;
function $m_Lapp_pages_AppPage$Root$() {
  if ((!$n_Lapp_pages_AppPage$Root$)) {
    $n_Lapp_pages_AppPage$Root$ = new $c_Lapp_pages_AppPage$Root$();
  }
  return $n_Lapp_pages_AppPage$Root$;
}
export { $m_Lapp_pages_AppPage$Root$ as $m_Lapp_pages_AppPage$Root$ };
//# sourceMappingURL=app.pages.-App-Page$-Root$.js.map
